(function () {
  function setupFilters(root) {
    root.querySelectorAll('[data-spr-library]').forEach(function (library) {
      var chips = Array.from(library.querySelectorAll('[data-spr-filter]'));
      var cards = Array.from(library.querySelectorAll('[data-spr-story]'));
      var counter = library.querySelector('[data-spr-results-count]');
      var clear = library.querySelector('[data-spr-filter-clear]');

      function render() {
        var active = chips.filter(function (chip) { return chip.getAttribute('aria-pressed') === 'true'; })
          .map(function (chip) { return chip.dataset.sprFilter.toLowerCase(); });
        var visible = 0;
        cards.forEach(function (card) {
          var tags = (card.dataset.tags || '').toLowerCase();
          var matches = active.every(function (filter) { return tags.indexOf(filter) !== -1; });
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (counter) counter.textContent = visible;
        if (clear) clear.hidden = active.length === 0;
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          render();
        });
      });
      if (clear) clear.addEventListener('click', function () {
        chips.forEach(function (chip) { chip.setAttribute('aria-pressed', 'false'); });
        render();
      });
      render();
    });
  }

  function setupFinder(root) {
    root.querySelectorAll('[data-spr-finder]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var base = form.dataset.locatorUrl;
        var input = form.querySelector('input');
        var status = form.querySelector('[data-spr-finder-status]');
        if (!input || !input.value.trim()) {
          if (status) status.textContent = 'Vul eerst een postcode of plaats in.';
          if (input) input.focus();
          return;
        }
        if (!base) {
          if (status) status.textContent = 'Koppel in de Theme Editor eerst de URL van de winkelzoeker.';
          return;
        }
        var joiner = base.indexOf('?') === -1 ? '?' : '&';
        window.location.href = base + joiner + 'q=' + encodeURIComponent(input.value.trim());
      });
    });
  }

  function setupGalleries(root) {
    root.querySelectorAll('[data-spr-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-spr-gallery-main]');
      gallery.querySelectorAll('[data-spr-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main || !thumb.dataset.imageUrl) return;
          main.src = thumb.dataset.imageUrl;
          gallery.querySelectorAll('[data-spr-gallery-thumb]').forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
          thumb.setAttribute('aria-pressed', 'true');
        });
      });
    });
  }

  function init(scope) {
    setupFilters(scope);
    setupFinder(scope);
    setupGalleries(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
